module.exports = __webpack_public_path__ + "img/map2.d99ca510.png";